<template>
    <div id="loading">
        <PulseLoader :color="'#303C54'" :size="'20px'"></PulseLoader>
    </div>
</template>

<script>
    import PulseLoader from 'vue-spinner/src/PulseLoader'

    export default {
        name: 'Loading',
        components: {
            PulseLoader
        }
    }
</script>

<style scoped>
    #loading {
        align-items: center;
        display: flex;
        background: rgba(255, 255, 255, 0.7);
        height: 100%;
        justify-content: center;
        position: fixed;
        width: 100%;
        z-index: 999;
    }
</style>
